<template>
  <div class="modal">
    <div v-if="!isMobile" class="modal-dialog" v-click-outside="closeModal">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">History of {{ prefix }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <vxe-table
            empty-text="No data"
            border="outer"
            :row-config="rowConfig"
            :data="tableData"
          >
            <vxe-column
              field="timestamp"
              title="Date"
              sortable
              sort-by="timestamp"
              width="20%"
              :formatter="formatDate"
            ></vxe-column>
            <vxe-column
              field="reason"
              title="Incident"
              sortable
              sort-by="reason"
              width="50%"
              :formatter="formatIncident"
            ></vxe-column>
            <vxe-column
              field="alertName"
              title="Alert name"
              sortable
              width="30%"
              sort-by="alertName"
            ></vxe-column>
          </vxe-table>
        </div>
      </div>
    </div>

    <div
      v-if="isMobile"
      id="mobile"
      class="modal-dialog"
      v-click-outside="closeModal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">History of {{ prefix }}</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <ul>
            <li v-for="(item, index) in tableData" :key="index">
              <div class="date">
                <span>Date</span>
                <span>{{ item.timestamp | dateFormatter }}</span>
              </div>
              <div class="incident">
                <span>Incident</span>
                <span>{{ item.reason }} </span>
              </div>
              <div class="alert-name">
                <span>Alert name</span>
                <span>{{ item.alertName }} </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import * as vClickOutside from 'v-click-outside';

export default {
  name: 'PrefixDetails',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: ['prefixHistoryData', 'prefix', 'alertName'],
  data() {
    return {
      rowConfig: { isHover: false },
      tableData: this.prefixHistoryData
    };
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  methods: {
    formatDate({ cellValue }) {
      const date = cellValue
        ? dayjs(cellValue).toString()
          ? dayjs(cellValue)
              .toString()
              .substring(4, 16)
          : ''
        : '-';
      return date;
    },
    formatIncident({ cellValue }) {
      return cellValue;
    },
    closeModal() {
      this.$emit('onCloseModal');
    }
  },
  mounted() {
    // Close modal with 'esc' key
    document.addEventListener('keydown', e => {
      if (e.code == 'Escape') {
        this.closeModal();
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($color: #000000, $alpha: 0.6);
}

.modal-dialog {
  max-width: initial;
  width: 80%;
  max-width: 45rem;
}

.modal-body {
  padding: 1rem 2rem;
  height: 60vh;
  overflow-y: scroll;
}

#mobile {
  &.modal-dialog {
    width: 90%;
  }

  .modal-body {
    padding: 0;
    height: calc(90vh - 6rem);
    overflow-y: scroll;
  }

  ul {
    list-style: none;
  }

  li {
    border-bottom: 1px solid #ddd;
    padding: 1rem 1.5rem;
  }

  .date,
  .incident,
  .alert-name {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .date,
  .incident {
    margin-bottom: 1rem;
  }

  .date span:nth-child(1),
  .incident span:nth-child(1),
  .alert-name span:nth-child(1) {
    color: $icon-grey;
    font-weight: 600;
  }

  .date span:nth-child(2),
  .incident span:nth-child(2),
  .alert-name span:nth-child(2) {
    text-align: right;
  }
}
</style>
